// extracted by mini-css-extract-plugin
export var button = "SliderNavigation-module--button--b9e1d";
export var buttonNext = "SliderNavigation-module--buttonNext--2df59";
export var buttonPrev = "SliderNavigation-module--buttonPrev--7a32c";